import script from "./BlankScaleValue.vue?vue&type=script&setup=true&lang=ts"
export * from "./BlankScaleValue.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__